export const questionsCategoryOptions = {
  '1534053372201': {
    __meta__: {
      createdBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      createdDate: '2018-08-12T05:56:12.201Z',
    },
    category: 'Boundaries',
    id: 1534053372201,
  },
  '1534053384042': {
    __meta__: {
      createdBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      createdDate: '2018-08-12T05:56:24.042Z',
    },
    category: 'Availability',
    id: 1534053384042,
  },
  '1534053393283': {
    __meta__: {
      createdBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      createdDate: '2018-08-12T05:56:33.283Z',
    },
    category: 'Stability',
    id: 1534053393283,
  },
  '1534053400376': {
    __meta__: {
      createdBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      createdDate: '2018-08-12T05:56:40.376Z',
    },
    category: 'Kindness',
    id: 1534053400376,
  },
};



// WEBPACK FOOTER //
// ./src/api/data/_questions-category-options.js